import { Tag } from "primereact/tag";

import { StationVisibility } from "../../../hooks/useStationVisibility";

const PRESENTATION: Record<StationVisibility, { value: string; icon: string; severity?: "success" }> = {
  PUBLIC: { value: "Public", icon: "pi pi-globe", severity: "success" },
  PRIVATE: { value: "Private", icon: "pi pi-lock" },
  UNKNOWN: { value: "Unknown", icon: "pi pi-question-circle" },
};

const NEUTRAL = { backgroundColor: "#e5e7eb", color: "#111827" };

const NOTIFICATION_NOTE: Record<StationVisibility, string> = {
  PUBLIC: "Owners are notified when it times out.",
  PRIVATE: "Owners are not notified: alerts only go out for public stations.",
  UNKNOWN: "Could not read whether this station is public.",
};

const EXCLUDED_NOTE = "Owners are not notified: the station is on the exclusion list.";

/** Whether a station is published (public) in eRound and whether it is excluded, which decide if its owners get timeout alerts. */
const StationVisibilityTag = ({
  visibility,
  withNote = false,
  excluded = false,
}: {
  visibility?: StationVisibility;
  withNote?: boolean;
  excluded?: boolean;
}) => {
  if (!visibility) {
    return <span className="text-color-secondary text-sm" data-testid="station-visibility-loading">…</span>;
  }

  const { value, icon, severity } = PRESENTATION[visibility];
  return (
    <div className="flex align-items-center gap-2" data-testid="station-visibility">
      <Tag value={value} icon={icon} severity={severity} style={severity ? undefined : NEUTRAL} />
      {excluded && <Tag value="Excluded" icon="pi pi-ban" severity="warning" />}
      {withNote && (
        <span className="text-sm text-color-secondary">
          {excluded ? EXCLUDED_NOTE : NOTIFICATION_NOTE[visibility]}
        </span>
      )}
    </div>
  );
};

export default StationVisibilityTag;
